import { ref } from "vue"
import { defineComponent, inferProps, type ReactiveComponent } from "vue-utils"
import CancelSubmitForm from "../form/CancelSubmitForm"

interface Props {
	existingValue: number | null
	minimum?: number
	maximum?: number
	placeholder: string
	cancel(): void
	select(value: number): void
}

const SelectNumberForm: ReactiveComponent<Props> = (props) => {
	const value = ref<number | null>(props.existingValue)

	return () => (
		<CancelSubmitForm onCancel={props.cancel} onSubmit={() => props.select(value.value!)} submitText="Go">
			<input
				autofocus
				class="w-full"
				placeholder={props.placeholder}
				type="number"
				v-model={value.value}
				min={props.minimum}
				max={props.maximum}
				required
			/>
		</CancelSubmitForm>
	)
}

export default defineComponent(SelectNumberForm, inferProps<Props>())
